import { CardGrid, CategoryTile, EmptyState } from '@beautyburst/ui';
import { semanticColor, space, typeStyle } from '@beautyburst/tokens';
import { customerHref } from '../base-path.ts';
import type { CategoryTileRow } from '@beautyburst/customer';

export function CategoriesScreen({
  categories,
  mediaUrlFor,
}: {
  categories: readonly CategoryTileRow[];
  mediaUrlFor?: (mediaKey: string) => string | null;
}) {
  return (
    <section aria-labelledby="categories-heading" style={{ display: 'grid', gap: space[5] }}>
      <h1
        id="categories-heading"
        style={{ ...typeStyle('headingLg'), color: semanticColor.textPrimary, margin: 0 }}
      >
        Shop categories
      </h1>
      {categories.length === 0 ? (
        <section aria-labelledby="categories-status-title">
          <h2
            id="categories-status-title"
            style={{ ...typeStyle('headingSm'), color: semanticColor.textPrimary }}
          >
            Category availability
          </h2>
          <EmptyState
            title="Categories are being curated"
            description="Check back soon for products available in your area."
            action={<a href={customerHref('/stores')}>Explore nearby stores</a>}
          />
        </section>
      ) : (
        <CardGrid label="Beauty categories">
          <>
            {categories.map((category) => (
              <li key={category.category_id}>
                <CategoryTile
                  href={customerHref(`/categories/${category.slug}`)}
                  displayName={category.display_name ?? category.name}
                  imageUrl={
                    category.tile_media_key === null || mediaUrlFor === undefined
                      ? null
                      : mediaUrlFor(category.tile_media_key)
                  }
                  imageAlt={
                    category.tile_alt_text ?? `${category.display_name ?? category.name} products`
                  }
                />
              </li>
            ))}
          </>
        </CardGrid>
      )}
    </section>
  );
}
